import { load } from 'recaptcha-v3';

const fetchV3RecaptchaToken = async () => {
  const recaptcha = await load(window.env.V3_site_key);
  return recaptcha.execute('Balance_Inquiry');
};

export default fetchV3RecaptchaToken;
